const utils = require('frontend-controller/lib/utils')

module.exports = {
    methods: {
        async onHeartbeat(message, heartbeatPrewarmedResourceHashes){
            const key    = message.heartbeatKey
            const userData  = ((storage || {}).user || {}).data || {}
            const myUserID      = userData.userID

            if(
                myUserID &&
                (
                    (
                        // NOTE: this one has no triggers at the moment
                        key === 'resourceChanged.cms_users' &&
                        (
                            myUserID == message.data.primaryKey ||
                            message.data.primaryKeys[myUserID] ||
                            myUserID == message.data.userID ||
                            (message.data.userIDs || {})[myUserID]
                        )
                    ) ||
                    (
                        key === 'accountChanged' &&
                        (
                            myUserID == message.data.userID ||
                            (message.data.userIDs || {})[myUserID]
                        )
                    )
                )
            ){
                const onDecisionPromise = utils.promise.newCustom(this)
                await this.performMessage({
                    onDecisionPromise,
                    messageDisplay: {
                        message: 'userController.reloadAfterReloginMandatingUserChanges'
                    }
                })
                await onDecisionPromise
                window.location.href = window.location.href;
            }
            // if(refreshers[key] && (
            //     (
            //         key !== 'resourceChanged.bo_status' &&
            //         key !== 'resourceChanged.bo_projectTermJobStatus' &&
            //         key !== 'resourceChanged.bo_employees'
            //     ) ||
            //     (key === 'resourceChanged.bo_status' && this.isAtLeastOneStatusIDLoaded(message.data.statusIDs)) ||
            //     (key === 'resourceChanged.bo_projectTermJobStatus' && myEmployeeID && myEmployeeID == message.data.employeeID) ||
            //     (key === 'resourceChanged.bo_employees' && myEmployeeID && myEmployeeID == (message.data.primaryKey || message.data.employeeID))
            // )){
            //     this.delayedLastOf('refreshByHeartbeat', () => this.refresh(true, { refreshResourcesViaHeartbeatKey: key, heartbeatPrewarmedResourceHashes }), 50)
            // }
        },
    },

    handlers: [
        {
            name: 'heartbeat.resourceChanged',
            handle: function(callerComponent, message, heartbeatPrewarmedResourceHashes){
                this.onHeartbeat(message, heartbeatPrewarmedResourceHashes)
            }
        },
        {
            name: 'heartbeat.accountChanged',
            handle: function(callerComponent, message, heartbeatPrewarmedResourceHashes){
                this.onHeartbeat(message, heartbeatPrewarmedResourceHashes)
            }
        },
    ],
}